import { Collection } from 'modules/core/lib/mobx-rest'

import FormAccessGroupMembership from 'modules/surveys/store/models/FormAccessGroupMembership'

interface Data {
  access_ids: number[]
  access_group_id: number
  form_id: number
}

class FormAccessGroupMemberships extends Collection<FormAccessGroupMembership> {
  get cacheKey(): string {
    return 'surveysFormAccessGroupMemberships'
  }
  get indexes() {
    return ['access_id', 'access_group_id', 'form_id']
  }

  model() {
    return FormAccessGroupMembership
  }

  async bulkCreate(data: Data) {
    const value = await this.rpc('bulk_create', data)
    this.add(value)

    return value
  }
}

export default new FormAccessGroupMemberships()
